<!-- 商品标签-合并商品清单 -->
<template>
    <div v-loading="loading" style="padding: 10px 0">
        <div class="search-ctn" style="padding-top: 0; ">
            <el-button size="small" type="danger" class="search-btn" @click="destroyLabel" v-if="tableData.length > 0 && !GoodsData.IsMerged">一键销毁商品标签</el-button>
            <el-button size="small" class="search-btn btn-primary" @click="printAll" v-if="tableData.length > 0 && GoodsData.IsMerged && printBtn"
                >一键打印合并后商品标签</el-button
            >
        </div>
        <div class="table-ctn">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                :data="tableData"
                border=""
                style="width: 100%; margin-bottom: 10px"
                min-height="530px"
                v-if="!GoodsData.IsMerged"
            >
                <el-table-column show-overflow-tooltip label="标签编码" prop="LabelCode" width="180"> </el-table-column>
                <el-table-column show-overflow-tooltip label="汽配编码" width="160" prop="APCode"></el-table-column>
                <el-table-column show-overflow-tooltip label="汽配名称" prop="GoodName"></el-table-column>
                <el-table-column show-overflow-tooltip label="适用车型" prop="AutoSerise"></el-table-column>
                <el-table-column show-overflow-tooltip label="规格" width="60" prop="PackingSpec"></el-table-column>
                <el-table-column show-overflow-tooltip label="状态" width="80" prop="State">
                    <template slot-scope="scope">{{ scope.row.State | stateHandle }}</template></el-table-column
                >
                <el-table-column show-overflow-tooltip label="存放仓库" width="100" prop="StorageName"></el-table-column>
                <el-table-column show-overflow-tooltip label="存放仓位" width="100" prop="SpaceName"></el-table-column>
            </el-table>
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border="" style="width: 100%; margin-bottom: 10px" min-height="530px" v-else>
                <el-table-column show-overflow-tooltip label="标签编码" prop="LabelCode" width="180"> </el-table-column>
                <el-table-column show-overflow-tooltip label="原汽配编码" width="160" prop="APCode"></el-table-column>
                <el-table-column show-overflow-tooltip label="原汽配名称" width="160" prop="GoodName"></el-table-column>
                <el-table-column show-overflow-tooltip label="适用车型" prop="AutoSerise"></el-table-column>
                <el-table-column show-overflow-tooltip label="新汽配编码" width="160" prop="NewAPCode"></el-table-column>
                <el-table-column show-overflow-tooltip label="新汽配名称" width="160" prop="NewGoodName"></el-table-column>
                <el-table-column show-overflow-tooltip label="规格" width="60" prop="PackingSpec"></el-table-column>
                <el-table-column show-overflow-tooltip label="状态" width="80" prop="State">
                    <template slot-scope="scope">{{ scope.row.State | stateHandle }}</template></el-table-column
                >
                <el-table-column show-overflow-tooltip label="存放仓库" width="100" prop="StorageName"></el-table-column>
                <el-table-column show-overflow-tooltip label="存放仓位" width="100" prop="SpaceName"></el-table-column>
                <el-table-column label="操作" v-if="GoodsData.IsMerged" fixed="right" width="110">
                    <template slot-scope="scope">
                        <div class="operate">
                            <i class="pl10" @click="printLabel(scope.row)" v-if="!scope.row.IsPrinted">打印新标签</i>
                            <i class="pl10" @click="checkLabels(scope.row)" v-if="scope.row.IsPrinted">查看标签</i>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog :close-on-click-modal="false" title="已打印商品标签" :visible.sync="printedLabelsVisible" width="1100px" append-to-body>
            <div class="dialog-content" v-if="printedLabelsVisible">
                <div class="table-ctn">
                    <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="printedGoodsMergeLabes" border="" style="width: 100%; margin-bottom: 10px" min-height="530px">
                        <el-table-column show-overflow-tooltip label="标签编码" prop="LabelCode" width="180"> </el-table-column>
                        <el-table-column show-overflow-tooltip label="汽配编码" width="160" prop="APCode"></el-table-column>
                        <el-table-column show-overflow-tooltip label="汽配名称" prop="GoodName"></el-table-column>
                        <el-table-column show-overflow-tooltip label="适用车型" prop="AutoSerise"></el-table-column>
                        <el-table-column show-overflow-tooltip label="规格" width="80" prop="PackingSpec"></el-table-column>
                        <el-table-column show-overflow-tooltip label="状态" width="80" prop="State">
                            <template slot-scope="scope">{{ scope.row.State | stateHandle }}</template></el-table-column
                        >
                        <el-table-column show-overflow-tooltip label="存放仓库" width="100" prop="StorageName"></el-table-column>
                        <el-table-column show-overflow-tooltip label="存放仓位" width="100" prop="SpaceName"></el-table-column>
                    </el-table>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['GoodsData'],
    components: {},
    data() {
        return {
            loading: false,
            tableData: [],
            printedLabels: [],
            printedLabelsVisible: false,
            printBtn: false,
            printedGoodsMergeLabes: []
        };
    },
    filters: {
        stateHandle(value) {
            if (value == 0) {
                return '正常';
            } else if (value == 1) {
                return '已销毁';
            } else if (value == 2) {
                return '已离仓';
            }
        }
    },
    mounted() {
        this.getTableData();
    },
    methods: {
        getTableData() {
            let that = this;
            that.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetDelGoodsLabels?GoodsId=' + that.GoodsData.DelGoodsId + '&RsId=' + that.GoodsData.RsId
                })
                .then(res => {
                    that.loading = false;
                    let data = res.data;
                    if (!data) data = [];
                    that.tableData = data;
                    that.printBtn = data.some(e => !e.IsPrinted);
                })
                .catch(() => {
                    that.loading = false;
                });
        },
        destroyLabel() {
            let that = this;
            let isTuoGuan = false;
            that.tableData.forEach(item => {
                if (item.IsTuoGuan) {
                    isTuoGuan = true;
                    return;
                }
            });
            if (isTuoGuan) {
                this.$util.warningMsg('存在前置仓的标签，无法进行销毁！');
                return;
            }
            that.$util.elConfirm({
                content: '是否已将商品【' + that.GoodsData.DelAPCode + '】相关货物从货架上整理拣货出来？标签销毁后，将无法使用',
                noMsg: true,
                confirmButtonText: '确定销毁',
                cancelButtonText: '取消',
                confirm() {
                    that.loading = true;
                    that.$util
                        .axiosPost({
                            url: '/api/EntpGoods/DestroyDelGoodsLabels?GoodsId=' + that.GoodsData.DelGoodsId + '&RsId=' + that.GoodsData.RsId,
                            hideLoading: true
                        })
                        .then(res => {
                            if (res.errcode == 0) {
                                that.$util.successMsg('成功销毁标签');
                                that.getTableData();
                            } else that.$util.successMsg(res.errmsg);
                            that.loading = false;
                        })
                        .finally(() => {
                            that.loading = false;
                        });
                }
            });
        },
        printLabel(item) {
            let that = this;
            that.$util.elConfirm({
                content: '确认打印新标签吗？',
                noMsg: true,
                confirm() {
                    that.loading = true;
                    that.$util
                        .axiosPost({
                            url: '/api/EntpGoods/PrintGoodsMergeLabel',
                            data: {
                                LabelId: item.LabelId,
                                DelGoodsId: item.DelGoodsId,
                                KeepGoodsId: item.NewGoodsId
                            },
                            hideLoading: true
                        })
                        .then(res => {
                            if (res.errcode == 0) {
                                that.$util.successMsg('打印成功');
                                that.getTableData();
                            } else that.$util.successMsg(res.errmsg);
                            that.loading = false;
                        })
                        .finally(() => {
                            that.loading = false;
                        });
                }
            });
        },
        printAll() {
            let that = this;
            that.$util.elConfirm({
                content: '确认打印全部商品标签吗？',
                noMsg: true,
                confirm() {
                    that.loading = true;
                    that.$util
                        .axiosPost({
                            url: '/api/EntpGoods/PrintGoodsMergeAllLabel',
                            data: {
                                RsId: that.GoodsData.RsId,
                                DelGoodsId: that.GoodsData.DelGoodsId,
                                KeepGoodsId: that.GoodsData.KeepGoodsId
                            },
                            hideLoading: true
                        })
                        .then(res => {
                            if (res.errcode == 0) {
                                that.$util.successMsg('打印成功');
                                that.getTableData();
                            } else that.$util.successMsg(res.errmsg);
                            that.loading = false;
                        })
                        .finally(() => {
                            that.loading = false;
                        });
                }
            });
        },
        checkLabels(item) {
            let that = this;
            that.printedGoodsMergeLabes = [];
            that.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetPrintedGoodsMergeLabes?LabelId=' + item.NewLabelId
                })
                .then(res => {
                    that.loading = false;
                    let data = res.data;
                    if (!data) data = [];
                    that.printedGoodsMergeLabes = data;
                    that.printedLabelsVisible = true;
                })
                .catch(() => {
                    that.loading = false;
                    that.printedLabelsVisible = true;
                });
        }
    }
};
</script>

<style lang="less" scoped>
.operate {
    height: 30px;
    display: flex;
    align-items: center;
    .pl10 {
        padding-left: 10px;
        cursor: pointer;
        color: #409eff;
    }
}
</style>
